import { Activity, ActivityDto, BaseQueryParams, IResponsePaginate, WithMetadata } from '@/types';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ActivityService {
  BASEURL = `${environment.api.paramsUrl}/activite`;
  httpClient = inject(HttpClient);

  getActivitiesByCategory(categoryId: number): Observable<Activity[]> {
    return this.httpClient.get<Activity[]>(`${this.BASEURL}/categories_activite/${categoryId}`);
  }

  getAll(params: BaseQueryParams): Observable<IResponsePaginate<Activity>> {
    return this.httpClient.get<IResponsePaginate<Activity>>(`${this.BASEURL}`, { params: params as HttpParams });
  }

  getOne(id: number): Observable<WithMetadata<Activity>> {
    return this.httpClient.get<WithMetadata<Activity>>(`${this.BASEURL}/${id}`);
  }

  create(activity: ActivityDto): Observable<WithMetadata<Activity>> {
    return this.httpClient.post<WithMetadata<Activity>>(`${this.BASEURL}`, activity);
  }

  update(id: number, activity: ActivityDto): Observable<WithMetadata<Activity>> {
    return this.httpClient.put<WithMetadata<Activity>>(`${this.BASEURL}/${id}`, activity);
  }

  delete(id: number): Observable<WithMetadata<Activity>> {
    return this.httpClient.delete<WithMetadata<Activity>>(`${this.BASEURL}/${id}`);
  }
}
